import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ServerConnectionService } from '../server-connection.service';
import { SiteAdvertDay } from '../../../classes/site-advert-day';
import { UtilitiesService } from '../utilities.service';
import { CoreModule } from '../../core.module';

@Injectable({
	providedIn: CoreModule,
})
export class SiteAdvertDaysService {
	private _siteAdvertDaysStore = <ReplaySubject<Array<SiteAdvertDay>>> new ReplaySubject(1);

	private _siteAdvertDaysById = <ReplaySubject<Object>> new ReplaySubject(1);

	private dataStore = {
		siteAdvertDays: {
			store: [],
			byId: {},
		},
	};

	constructor(private scs: ServerConnectionService, private us: UtilitiesService) {
	}

	get siteAdvertDaysById$() {
		return this._siteAdvertDaysById.asObservable();
	}

	get siteAdvertDaysStore$() {
		return this._siteAdvertDaysStore.asObservable();
	}

	public fetchAvailableSiteAdvertDays(query) {
		return this.scs.http$('POST', '/api/site-adverts/get-available-site-adverts', null, query);
	}
}
